import React from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';
import { useTheme } from 'housecall-ui';

export const AutosuggestTextField = (props) => {
  const muiTheme = useTheme();
  const theme = {
    container: {
      position: 'relative',
      ...props.containerStyle,
    },
    input: {
      width: '100%',
    },
    suggestionsContainer: {
      display: 'none',
    },
    suggestionsContainerOpen: {
      width: '100%',
      display: 'block',
      position: 'absolute',
      fontFamily: 'Roboto, Arial, sans-serif',
      fontWeight: 400,
      lineHeight: 1.5,
      background: '#fff',
      zIndex: 7,
      height: 'auto',
      maxHeight: 400,
      overflowY: 'auto',
      boxShadow: '0 6px 12px 0 rgba(0,0,0,0.2)',
      transition: '0.3s',
      ...props.inputStyle,
    },
    suggestionsList: {
      padding: 0,
      margin: 0,
      listStyleType: 'none',
    },
    suggestion: {
      cursor: 'pointer',
      padding: props.dense ? '0px' : '10px 20px',
      margin: props.dense ? '0px auto' : '0px',
    },
    suggestionHighlighted: {
      backgroundColor: (props.useSuggestionPrimaryColor && muiTheme?.palette.aliceBlue?.main) || '#d8d8d8',
    },
  };

  return (
    <Autosuggest
      theme={theme}
      renderInputComponent={props.renderInputComponent}
      getSuggestionValue={props.getSuggestionValue}
      {...props}
    />
  );
};

AutosuggestTextField.propTypes = {
  id: PropTypes.string,
  suggestions: PropTypes.array,
  renderInputComponent: PropTypes.func.isRequired,
  renderSuggestion: PropTypes.func.isRequired,
  onSuggestionsFetchRequested: PropTypes.func.isRequired,
  onSuggestionsClearRequested: PropTypes.func,
  inputProps: PropTypes.object.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  getSuggestionValue: PropTypes.func,
  containerStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  shouldRenderSuggestions: PropTypes.func,
  alwaysRenderSuggestions: PropTypes.bool,
  renderSuggestionsContainer: PropTypes.func,
  multiSection: PropTypes.bool,
  renderSectionTitle: PropTypes.func,
  getSectionSuggestions: PropTypes.func,
  useSuggestionPrimaryColor: PropTypes.bool,
  focusInputOnSuggestionClick: PropTypes.bool,
};

AutosuggestTextField.defaultProps = {
  dense: false,
  getSuggestionValue: (value) => value,
};
